import QAReporterPage from "./QAReporterPage.component.jsx";

export default QAReporterPage;
